import { Form } from "antd";
import { useParams } from "react-router";

import { EmvConfigurationsTable } from "src/app/features/EmvKernelProfile/subFeatures/EmvConfiguration/components/tables/EmvConfigurationsTable";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";

export const EmvKernelProfilesEmvConfigurationsTableField: FieldMethod = ({ field }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return id ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <EmvConfigurationsTable key={field.name} />
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
